import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
// 🔥 Firebase imports
import { auth } from "./firebase";
import { 
  signInWithEmailAndPassword, 
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  updateProfile,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
// Database fonksiyonları
import { getEmailByUsername, isUsernameAvailable, syncUserToDB } from "./database";

// 🎨 İKONLAR (Basit SVG'ler)
const Icons = {
  User: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
  Mail: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>,
  Lock: () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>,
  Google: () => <svg width="20" height="20" viewBox="0 0 18 18"><path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" /><path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.258c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332C2.438 15.983 5.482 18 9 18z" /><path fill="#FBBC05" d="M3.964 10.707c-.18-.54-.282-1.117-.282-1.707 0-.593.102-1.17.282-1.709V4.958H.957C.347 6.173 0 7.548 0 9s.348 2.827.957 4.042l3.007-2.335z" /><path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0 5.482 0 2.438 2.017.957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" /></svg>
};

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const [isSignUp, setIsSignUp] = useState(location.pathname === '/signup');
  const [username, setUsername] = useState("");
  const [emailOrUsername, setEmailOrUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [resetSuccess, setResetSuccess] = useState(false);
  const [verificationSent, setVerificationSent] = useState(false);
  
 


  // --- YENİ EKLENEN STATE: Password Strength ---
  const [strengthScore, setStrengthScore] = useState(0); // 0: Yok, 1: Weak, 2: Medium, 3: Strong


  const switchMode = (signUpMode) => {
    setIsSignUp(signUpMode);
    // URL'yi güncelle
    navigate(signUpMode ? '/signup' : '/signin', { replace: true });
  };

  useEffect(() => {
    const savedLogin = localStorage.getItem("rememberedLogin");
    if (savedLogin) {
      setEmailOrUsername(savedLogin);
      setRememberMe(true);
    }
  }, []);

  // --- ŞİFRE GÜCÜ HESAPLAMA FONKSİYONU ---
  useEffect(() => {
    if (!password) {
      setStrengthScore(0);
      return;
    }
    let score = 0;
    // Kriter 1: En az 6 karakter (Temel)
    if (password.length >= 6) score = 1;

    // Kriter 2: En az 8 karakter VE (Sayı VEYA Özel Karakter)
    if (password.length >= 8 && (/\d/.test(password) || /[!@#$%^&*(),.?":{}|<>]/.test(password))) {
      score = 2;
    }

    // Kriter 3: En az 10 karakter VE Büyük Harf VE (Sayı VEYA Özel Karakter)
    if (password.length >= 10 && /[A-Z]/.test(password) && (/\d/.test(password) || /[!@#$%^&*(),.?":{}|<>]/.test(password))) {
      score = 3;
    }
    
    setStrengthScore(score);
  }, [password]);

  useEffect(() => {
  setIsSignUp(location.pathname === '/signup');
}, [location.pathname]);

  const allowedEmailDomains = [
  'gmail.com', 'googlemail.com', 'outlook.com', 'hotmail.com', 
  'live.com', 'yahoo.com', 'yahoo.co.uk', 'yahoo.fr',
  'icloud.com', 'me.com', 'mac.com',
  'protonmail.com', 'proton.me',
  'mail.com', 'aol.com', 'zoho.com', 'yandex.com',
  'gmx.com', 'gmx.net'
  ];

  const isValidEmail = (email) => {
  const domain = email.split('@')[1]?.toLowerCase();
  if (!domain) return false;
  return allowedEmailDomains.includes(domain);
  };

  const handleSubmit = async (e) => {
    if(e) e.preventDefault();
    if (loading) return;
    setError("");
    setResetSuccess(false);
    

    if (isSignUp) {
      if (!username || username.trim().length < 3) {
        setError("Username must be at least 3 characters!");
        setLoading(false); return;
      }
      if (!/^[a-zA-Z0-9_]+$/.test(username)) {
        setError("Only letters, numbers, and underscores!");
        setLoading(false); return;
      }
      if (password !== confirmPassword) {
        setError("Passwords do not match!");
        setLoading(false); return;
      }
      
      // --- YENİ KONTROL: Zayıf Şifreyi Engelle ---
      if (strengthScore < 2) {
        setError("⚠️ Password is too weak! Try adding numbers or special characters.");
        setLoading(false); return;
      }
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters!");
      setLoading(false); return;
    }

    if (isSignUp && !isValidEmail(emailOrUsername)) {
    setError("⚠️ Please use a valid email provider (Gmail, Outlook, Yahoo, etc.)");
    setLoading(false); 
    return;
    }
    setLoading(true);
    try {
      if (rememberMe) {
        await setPersistence(auth, browserLocalPersistence);
        localStorage.setItem("rememberedLogin", emailOrUsername);
      } else {
        await setPersistence(auth, browserSessionPersistence);
        localStorage.removeItem("rememberedLogin");
      }

      if (isSignUp) {
        // --- KAYIT ---
        const available = await isUsernameAvailable(username);
        if (!available) {
          setError("This username is already taken.");
          setLoading(false); return;
        }

        const userCredential = await createUserWithEmailAndPassword(auth, emailOrUsername, password);
        
        await updateProfile(userCredential.user, { displayName: username });

        await sendEmailVerification(userCredential.user);

        await syncUserToDB(userCredential.user, username);

        setVerificationSent(true);
        setLoading(false);
        
        setTimeout(() => {
          setIsSignUp(false);
          setVerificationSent(false);
        }, 5000);
        return;
        
      } else {
        // --- GİRİŞ ---
        let loginEmail = emailOrUsername;
        if (!emailOrUsername.includes('@')) {
          const foundEmail = await getEmailByUsername(emailOrUsername);
          if (!foundEmail) {
            setError("User not found.");
            setLoading(false); return;
          }
          loginEmail = foundEmail;
        }
        const userCredential = await signInWithEmailAndPassword(auth, loginEmail, password);
        if (!userCredential.user.emailVerified) {
        setError("⚠️ Your email is not verified! Please click the link in your email.");
        await auth.signOut();
        setLoading(false);
        return;
        }
        await syncUserToDB(userCredential.user);
      }
      setLoading(false); 
      console.log("Success! Redirecting...");
      navigate('/studio');
      
    } catch (err) {
      console.error(err);
      let msg = "An error occurred.";
      if (err.code === "auth/email-already-in-use") msg = "Email is already in use.";
      else if (err.code === "auth/wrong-password") msg = "Incorrect password.";
      else if (err.code === "auth/user-not-found") msg = "User not found.";
      else if (err.code === "auth/invalid-credential") msg = "Invalid login credentials.";
      setError(msg);
      setLoading(false);
    }
  };

  const handleForgotPassword = async () => {
    if (!emailOrUsername) {
      setError("Please enter your email or username.");
      return;
    }
    let resetEmail = emailOrUsername;
    setLoading(true);
    try {
      if (!emailOrUsername.includes('@')) {
        const foundEmail = await getEmailByUsername(emailOrUsername);
        if (!foundEmail) throw new Error("User not found");
        resetEmail = foundEmail;
      }
      await sendPasswordResetEmail(auth, resetEmail);
      setResetSuccess(true);
      setTimeout(() => { setShowForgotPassword(false); setResetSuccess(false); }, 3000);
    } catch (err) {
      setError("Email could not be sent or user does not exist.");
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");

    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      const user = result.user;

      await syncUserToDB(user, user.displayName || "Kullanıcı");

      console.log("Google login successful!");
      navigate('/studio'); 

    } catch (err) {
      console.error("Google Login Error:", err);
      if (err.code !== 'auth/popup-closed-by-user') {
        setError("Google login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  // --- STYLES (Modern) ---
  const styles = {
    container: {
      minHeight: "100vh",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      background: "linear-gradient(135deg, #121212 0%, #1e1e2f 100%)",
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
      color: "#fff",
      position: "relative",
      overflow: "hidden"
    },
    bgOrb: {
      position: "absolute",
      width: "500px",
      height: "500px",
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(124, 58, 237, 0.2) 0%, rgba(0,0,0,0) 70%)",
      top: "-10%",
      left: "-10%",
      zIndex: 0
    },
    bgOrb2: {
      position: "absolute",
      width: "400px",
      height: "400px",
      borderRadius: "50%",
      background: "radial-gradient(circle, rgba(59, 130, 246, 0.15) 0%, rgba(0,0,0,0) 70%)",
      bottom: "0%",
      right: "-5%",
      zIndex: 0
    },
    card: {
      width: "100%",
      maxWidth: "400px",
      padding: "40px",
      borderRadius: "24px",
      backgroundColor: "rgba(255, 255, 255, 0.03)",
      backdropFilter: "blur(20px)",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.5)",
      zIndex: 1,
      transition: "all 0.3s ease"
    },
    title: {
      fontSize: "28px",
      fontWeight: "700",
      marginBottom: "8px",
      textAlign: "center",
      background: "linear-gradient(to right, #fff, #a5b4fc)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    },
    subtitle: {
      textAlign: "center",
      color: "#94a3b8",
      fontSize: "14px",
      marginBottom: "32px"
    },
    inputGroup: {
      marginBottom: "20px",
      position: "relative"
    },
    inputIcon: {
      position: "absolute",
      left: "16px",
      top: "50%",
      transform: "translateY(-50%)",
      color: "#94a3b8"
    },
    input: {
      width: "100%",
      padding: "16px 16px 16px 48px",
      backgroundColor: "rgba(0, 0, 0, 0.2)",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      borderRadius: "16px",
      color: "#fff",
      fontSize: "15px",
      outline: "none",
      transition: "all 0.2s",
      boxSizing: "border-box"
    },
    button: {
      width: "100%",
      padding: "16px",
      borderRadius: "16px",
      border: "none",
      background: loading 
        ? "#334155" 
        : "linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)",
      color: "#fff",
      fontSize: "16px",
      fontWeight: "600",
      cursor: loading ? "wait" : "pointer",
      transition: "transform 0.1s, opacity 0.2s",
      marginBottom: "16px",
      boxShadow: "0 10px 15px -3px rgba(99, 102, 241, 0.3)"
    },
    googleBtn: {
      width: "100%",
      padding: "14px",
      borderRadius: "16px",
      border: "1px solid rgba(255, 255, 255, 0.1)",
      background: "rgba(255,255,255,0.05)",
      color: "#fff",
      fontSize: "14px",
      fontWeight: "500",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
      transition: "background 0.2s"
    },
    linkBtn: {
      background: "none",
      border: "none",
      color: "#818cf8",
      fontSize: "14px",
      cursor: "pointer",
      padding: "0",
      fontWeight: "500"
    },
    error: {
      background: "rgba(239, 68, 68, 0.15)",
      color: "#fca5a5",
      padding: "12px",
      borderRadius: "12px",
      fontSize: "13px",
      marginBottom: "20px",
      textAlign: "center",
      border: "1px solid rgba(239, 68, 68, 0.2)"
    },
    success: {
      background: "rgba(34, 197, 94, 0.15)",
      color: "#86efac",
      padding: "12px",
      borderRadius: "12px",
      fontSize: "13px",
      marginBottom: "20px",
      textAlign: "center",
      border: "1px solid rgba(34, 197, 94, 0.2)"
    },
    // --- YENİ STİL: Strength Meter Barı ---
    strengthBarContainer: {
        display: 'flex',
        gap: '4px',
        marginTop: '8px',
        paddingLeft: '10px',
        paddingRight: '10px'
    },
    strengthSegment: (active, color) => ({
        height: '4px',
        flex: 1,
        borderRadius: '2px',
        backgroundColor: active ? color : 'rgba(255,255,255,0.1)',
        transition: 'all 0.3s ease'
    }),
    strengthText: (color) => ({
        textAlign: 'right',
        fontSize: '11px',
        marginTop: '4px',
        color: color,
        fontWeight: '500',
        paddingRight: '10px'
    })
  };

  const handleFocus = (e) => e.target.style.borderColor = "#818cf8";
  const handleBlur = (e) => e.target.style.borderColor = "rgba(255, 255, 255, 0.1)";

  // ... (Forgot Password bloğu aynı kaldı) ...
  if (showForgotPassword) {
    return (
      <div style={styles.container}>
        <div style={styles.bgOrb} />
        <div style={styles.bgOrb2} />
        <div style={styles.card}>
          <h2 style={styles.title}>Forgot Password</h2>
          <p style={styles.subtitle}>Regain access to your account</p>

          {resetSuccess && <div style={styles.success}>✅ Reset link sent!</div>}
          {error && <div style={styles.error}>⚠️ {error}</div>}

          <div style={styles.inputGroup}>
            <span style={styles.inputIcon}><Icons.Mail /></span>
            <input
              type="text"
              placeholder="Email or Username"
              value={emailOrUsername}
              onChange={(e) => setEmailOrUsername(e.target.value)}
              style={styles.input}
              onFocus={handleFocus} onBlur={handleBlur}
            />
          </div>

          <button onClick={handleForgotPassword} disabled={loading} style={styles.button}>
            {loading ? "SENDING..." : "SEND LINK"}
          </button>

          <button onClick={() => { setShowForgotPassword(false); setError(""); }} style={{...styles.googleBtn, border: 'none', background: 'transparent'}}>
            Go Back
          </button>
        </div>
      </div>
    );
  }

  // --- RENK VE METİN BELİRLEME ---
  let strengthColor = '#ef4444'; // Kırmızı (Default/Zayıf)
  let strengthLabel = 'Weak';
  
  if (strengthScore === 2) {
      strengthColor = '#facc15'; // Sarı
      strengthLabel = 'Medium';
  } else if (strengthScore === 3) {
      strengthColor = '#22c55e'; // Yeşil
      strengthLabel = 'Strong';
  } else if (strengthScore === 0) {
      strengthLabel = '';
  }

  return (
    <div style={styles.container}>
      <div style={styles.bgOrb} />
      <div style={styles.bgOrb2} />
      
      <div style={styles.card}>
        <h1 style={styles.title}>SoundCode</h1>
        <p style={styles.subtitle}>
          {isSignUp ? "Join the music world" : "Welcome back"}
        </p>

        {error && <div style={styles.error}>{error}</div>}
        {verificationSent && (
        <div style={styles.success}>
          ✅ Registration successful! Verification link sent to your email. 
          <br />Please check your email and click the link.
        </div>
        )}

        <form onSubmit={handleSubmit}>
          {isSignUp && (
            <div style={styles.inputGroup}>
              <span style={styles.inputIcon}><Icons.User /></span>
              <input
                type="text"
                placeholder="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value.toLowerCase())}
                style={styles.input}
                onFocus={handleFocus} onBlur={handleBlur}
              />
            </div>
          )}

          <div style={styles.inputGroup}>
            <span style={styles.inputIcon}><Icons.Mail /></span>
            <input
              type={isSignUp ? "email" : "text"}
              placeholder={isSignUp ? "Email Address" : "Email or Username"}
              value={emailOrUsername}
              onChange={(e) => setEmailOrUsername(e.target.value)}
              style={styles.input}
              onFocus={handleFocus} onBlur={handleBlur}
            />
          </div>

          <div style={styles.inputGroup}>
            <div style={{ position: 'relative' }}>
            <span style={{...styles.inputIcon, top: '28px'}}><Icons.Lock /></span>
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
              onFocus={handleFocus} onBlur={handleBlur}
            />
            </div>
            {/* 🔥 YENİ: VISUAL PASSWORD STRENGTH INDICATOR (Sadece Kayıt Olurken) */}
            {isSignUp && password.length > 0 && (
                <div>
                    <div style={styles.strengthBarContainer}>
                        {/* Segment 1: Hep yanar eğer score >= 1 ise */}
                        <div style={styles.strengthSegment(strengthScore >= 1, strengthColor)}></div>
                        {/* Segment 2: Yanar eğer score >= 2 ise */}
                        <div style={styles.strengthSegment(strengthScore >= 2, strengthColor)}></div>
                        {/* Segment 3: Yanar eğer score >= 3 ise */}
                        <div style={styles.strengthSegment(strengthScore >= 3, strengthColor)}></div>
                    </div>
                    <div style={styles.strengthText(strengthColor)}>
                        {strengthLabel}
                    </div>
                </div>
            )}
          </div>

          {isSignUp && (
            <div style={styles.inputGroup}>
              <span style={styles.inputIcon}><Icons.Lock /></span>
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={styles.input}
                onFocus={handleFocus} onBlur={handleBlur}
              />
            </div>
          )}

          {!isSignUp && (
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px', fontSize: '13px', color: '#94a3b8'}}>
              <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer'}}>
                <input 
                  type="checkbox" 
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  style={{marginRight: '8px', accentColor: '#6366f1'}}
                />
                Remember me
              </label>
              <button type="button" onClick={() => setShowForgotPassword(true)} style={styles.linkBtn}>
                Forgot password?
              </button>
            </div>
          )}

          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? "PROCESSING..." : (isSignUp ? "SIGN UP" : "SIGN IN")}
          </button>
        </form>

        <div style={{display: 'flex', alignItems: 'center', margin: '20px 0', color: '#64748b'}}>
          <div style={{flex: 1, height: '1px', background: 'rgba(255,255,255,0.1)'}}></div>
          <span style={{padding: '0 10px', fontSize: '12px'}}>OR</span>
          <div style={{flex: 1, height: '1px', background: 'rgba(255,255,255,0.1)'}}></div>
        </div>

        <button type="button" onClick={handleGoogleLogin} disabled={loading} style={styles.googleBtn}>
        <Icons.Google /> Continue with Google
        </button>

        <div style={{textAlign: 'center', marginTop: '24px', fontSize: '14px', color: '#94a3b8'}}>
          {isSignUp ? "Already have an account? " : "Don't have an account? "}
          <button 
            onClick={() => { switchMode(!isSignUp); setError(""); }} 
            style={{...styles.linkBtn, fontWeight: '600', color: '#fff'}}
          >
            {isSignUp ? "Sign In" : "Sign Up"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Login;